import { DialogContentText } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Button from '../button/Button'
import Dialog, { DialogProps } from './Dialog'

export type DialogConfirmationProps = {
  contentText?: string
  cancelLabel?: string
  confirmLabel?: string
  isBtnConfirmDisabled?: boolean
  isBtnCancelDisabled?: boolean
  dialogStyle?: string
  maxWidth?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
  onCancel?(): void
  onConfirm?(): void
} & DialogProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionBtn: {
      width: '50%'
    },
    dialogSize: {
      '& .MuiDialog-paperWidthXs': {
        maxWidth: 396
      }
    }
  })
)

const DialogConfirmation: React.FC<DialogConfirmationProps> = (props) => {
  const {
    contentText,
    cancelLabel,
    confirmLabel,
    isBtnCancelDisabled,
    isBtnConfirmDisabled,
    maxWidth,
    dialogStyle,
    onCancel = (): void => {},
    onConfirm = (): void => {},
    ...rest
  } = props
  const classes = useStyles()
  return (
    <Dialog
      className={dialogStyle ? dialogStyle : classes.dialogSize}
      maxWidth={maxWidth ? maxWidth : 'xs'}
      content={
        <DialogContentText variant="body1">
          {contentText ? contentText : 'Are you sure?'}
        </DialogContentText>
      }
      action={
        <>
          <Button
            onClick={(): void => onCancel()}
            variants="ghost"
            disabled={isBtnCancelDisabled}
            children={cancelLabel ? cancelLabel : 'No'}
            className={classes.actionBtn}
          />
          <Button
            onClick={(): void => onConfirm()}
            variants="primary"
            disabled={isBtnConfirmDisabled}
            children={confirmLabel ? confirmLabel : 'Yes'}
            className={classes.actionBtn}
          />
        </>
      }
      {...rest}
    />
  )
}

export default DialogConfirmation
